
































































































































import { Component, Vue, Watch, Emit, Prop } from 'vue-property-decorator'; // デコレータ
import { Mutation, Action, VuexModule, getModule, Module } from 'vuex-module-decorators';
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
/* 画面固有 */
import { Constants } from '../../CommonUtils/fixed/Constants'; // 定数保管ファイル
import { Message } from '../../CommonUtils/fixed/Message'; // メッセージ
/* ストア、定数関連 */
import axios from 'axios';
import { supervisingModule } from '../../store/modules/OperationSupervising';
import { ScreenMode } from '../../CommonUtils/fixed/ScreenMode';
import { loadingControlModule } from '../../store/modules/LoadingControl';

// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

@Component
export default class Euc extends ApiAccessBase {
  private validate = require('../../CommonUtils/fixed/Validate'); // Validate
  @Prop() private value?: string;
  private disabled: boolean = true;
  private PRINTLIST: any = [];
  private name?: string;
  private rules: any;
  @Prop({default: true}) private required?: boolean;
  private variableList: any = [];
  @Prop() private index!: number;
  private SELNAME?: string;
  private conKey?: string;
  private conVal?: string;

  // validationの設定
  private isValidateRequired(value: string) {
    return this.validate.isValidateRequired(value, this.required);
  }

  @Emit('input')
  private selectValue(value: string) {
    this.errorMessage = ''; //エラーメッセージリセット
    this.variableList = undefined; //条件設定ラベル名リセット
    this.disabled = true; //条件設定ラベル、項目リセット
    const path = Constants.KANRI_URL + '/euc' + '/select';
    this.formData['SELNAME'] = value; //選択帳票名セット(サーバ側でPrintSelectDtoクラスの変数SELNAMEで受取)
    this.SELNAME = value;
    // APIアクセス
    this.axiosApi
      .post(path, this.formData)
      .then((response) => {
          this.variableList = response.data.entity.CONDLIST;
          if (this.variableList.length !== 0) {
            this.disabled = false; //条件設定が存在するSQLの場合は入力項目活性化
          }
      })
      .catch((error) => {
        this.errorMessage = error.response.data.code + ':' + error.response.data.message + '\n';
      })
      .finally(() => {
        loadingControlModule.endLoading();
      });
    return value;
  }

  @Emit('input')
  private updateValue(value: string) {
    return value;
  }
  // 画面初期化処理
  // component生成時に実行
  private created() {
    loadingControlModule.startLoading();
    // validationルールの設定
    this.rules = [
      (value: string) => (this.isValidateRequired(value)) || '必須項目です。',
      ];
    const path = Constants.KANRI_URL + '/euc/init';
    // // ファイルアップロード 可変項目取得
    // APIアクセス
    this.axiosApi
      .get(path)
      .then((response) => {
        this.PRINTLIST = response.data.entity.PRINTLIST;
        supervisingModule.setMode(response.data.screenMode);
      })
      .catch((error) => {
        this.errorMessage = error.response.data.code + ':' + error.response.data.message + '\n';
      })
      .finally(() => {
        loadingControlModule.endLoading();
      });
  }

  /**
　  * ファイルダウンロード
　  */
  private async download() {
    // formのバリデーション
    if (!this.validateForm(this.$refs.form)) {
      return;
    }
    if (this.errorMessage !== '') {
      return;
    }
    const path = Constants.KANRI_URL + '/euc/print';
    // ボタン押下時
    if (window.confirm(Message.I0021)) {
      loadingControlModule.startLoading();
      if (this.variableList.length !== 0) {
        this.conKey = ''; //条件キーリセット
        this.conVal = ''; //条件値リセット
      } else {
        this.conKey = '@PE@'; //初期値：条件キーの設定がない場合のArrayindexoutofexception対策
        this.conVal = '@PE@'; //初期値：条件キーの設定がない場合のArrayindexoutofexception対策
      }
      const joken: any = this.$refs.joken;
      for (const variablecol of Object.keys(this.variableList)) { //条件設定がある場合
        if (variablecol === '0') {
          this.conKey += this.variableList[variablecol].name;
          this.conVal += joken[variablecol].internalValue;
        } else {
          this.conKey += '@PE@' + this.variableList[variablecol].name;
          this.conVal += '@PE@' + joken[variablecol].internalValue;
        }
      }

      await this.axiosApi
      .get(path, {
            responseType: 'blob',
            params: {
              printID: this.SELNAME, //帳票ID
              conKey: this.conKey, //条件キーリスト
              conVal: this.conVal, //条件値リスト
              printflg: 1, //printToolによる出力(1以外:printEngine)
              formatID: this.SELNAME, //Excelファイル名
              downloadFileName: this.SELNAME, //ダウンロードファイル名
            },
      })
      .then((response) => {
        const blob = new Blob([response.data], { type : '*/*' });
        let filename = '';
        const disposition = response.headers['content-disposition'];
        if (disposition && disposition.indexOf('attachment') !== -1) {
            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            const matches = filenameRegex.exec(disposition);
            if (matches !== null && matches[1]) {
              filename = decodeURI(matches[1]).replace(/['"]/g, '').replace(/[+]/g, ' '); //UTF-8のファイル名をデコード後、半角スペースが+に置換されるのをさらに置換
            }
        }
        if (window.navigator.msSaveBlob) {
          // IEとEdge
          window.navigator.msSaveBlob(blob, filename);
        } else {
          // それ以外のブラウザ
          // Blobオブジェクトを指すURLオブジェクトを作る
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
        }
        // 成功
        this.errorMessage = ''; //エラーメッセージリセット
        // alert(Message.I0022);
      })
      .catch(async (error) => {
        let textError: any;
        textError = await this.onBlobHandler(error); //ダウンロード時はレスポンスタイプがblobの為エラーメッセージがそのままでは取得出来ない。非同期処理でテキストに変換
        this.errorMessage = textError.code + ':' + textError.message + '\n';
        alert(Message.E0000);
      })
      .finally(() => {
        loadingControlModule.endLoading();
      });
    }
  }

  /**
   * responseType: 'blob'で返却されたerrorからstringのメッセージを抽出
   */
  private async onBlobHandler(error: any) {
    let text: any = '';
    const result = await this.fileReader(error.response.data);
    text = result;
    return JSON.parse(text);
  }

  /**
   * 非同期にBlobをテキストとして読み込み
   */
  private fileReader(blob: any) {
    const fileReader = new FileReader();

    return new Promise((resolve: any, reject) => {
      fileReader.onerror = () => {
        fileReader.abort();
        reject();
      };

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.readAsText(blob);
    });
  }
}
